import {
  apiSlice,
} from '../../app/api/apiSlice';


const orderApi =
  apiSlice.enhanceEndpoints({
    addTagTypes: [
      'Order',
    ],
  });


export const ordersApiSlice =
  orderApi.injectEndpoints({
    endpoints:
      (builder) => ({
        /*
         * CHECKOUT
         */
        createOrder:
          builder.mutation({
            query:
              (checkoutData) => ({
                url:
                  '/api/orders/checkout-session',

                method:
                  'POST',

                body:
                  checkoutData,
              }),
          }),


        getCheckoutStatus:
          builder.query({
            query:
              (sessionId) =>
                `/api/orders/session/${encodeURIComponent(
                  sessionId
                )}`,
          }),


        createPurchasedAccountSetup:
          builder.mutation({
            query:
              (sessionId) => ({
                url:
                  `/api/orders/session/${encodeURIComponent(
                    sessionId
                  )}/account-setup`,

                method:
                  'POST',
              }),
          }),


        activatePurchasedAccount:
          builder.mutation({
            query:
              (body) => ({
                url:
                  '/api/orders/account/activate',

                method:
                  'POST',

                body,
              }),
          }),

        getCheckoutProfile:
          builder.query({
            query:
              () =>
                '/api/orders/checkout-profile',
          }),
        /*
         * CUSTOMER
         */
        getMyOrders:
          builder.query({
            query:
              () =>
                '/api/orders/mine',

            providesTags:
              (result) => [
                {
                  type:
                    'Order',

                  id:
                    'MY_ORDERS',
                },

                ...(
                  result?.orders ||
                  []
                ).map(
                  (order) => ({
                    type:
                      'Order',

                    id:
                      order._id,
                  })
                ),
              ],
          }),


        /*
         * PUBLIC LINK
         */
        getPublicOrderStatus:
          builder.query({
            query:
              (token) =>
                `/api/orders/public/${encodeURIComponent(
                  token
                )}`,

            providesTags:
              (
                result
              ) =>
                result?.order
                  ? [
                    {
                      type:
                        'Order',

                      id:
                        result
                          .order
                          ._id,
                    },
                  ]
                  : [],
          }),


        /*
         * ADMIN
         */
        getAdminOrders:
          builder.query({
            query:
              (params = {}) => ({
                url:
                  '/api/orders/admin',

                params,
              }),

            providesTags:
              (result) => [
                {
                  type:
                    'Order',

                  id:
                    'ADMIN_LIST',
                },

                ...(
                  result?.orders ||
                  []
                ).map(
                  (order) => ({
                    type:
                      'Order',

                    id:
                      order._id,
                  })
                ),
              ],
          }),


        updateOrderFulfillment:
          builder.mutation({
            query:
              ({
                orderId,
                ...fulfillment
              }) => ({
                url:
                  `/api/orders/admin/${encodeURIComponent(
                    orderId
                  )}/fulfillment`,

                method:
                  'PATCH',

                body:
                  fulfillment,
              }),

            invalidatesTags:
              (
                result,
                error,
                arg
              ) => [
                  {
                    type:
                      'Order',

                    id:
                      arg.orderId,
                  },

                  {
                    type:
                      'Order',

                    id:
                      'ADMIN_LIST',
                  },

                  {
                    type:
                      'Order',

                    id:
                      'MY_ORDERS',
                  },
                ],
          }),


        createPublicOrderStatusLink:
          builder.mutation({
            query:
              (orderId) => ({
                url:
                  `/api/orders/admin/${encodeURIComponent(
                    orderId
                  )}/public-link`,

                method:
                  'POST',
              }),
          }),
      }),
  });


export const {
  useCreateOrderMutation,
  useGetCheckoutStatusQuery,
  useCreatePurchasedAccountSetupMutation,
  useActivatePurchasedAccountMutation,
  useGetCheckoutProfileQuery,
  useGetMyOrdersQuery,
  useGetPublicOrderStatusQuery,

  useGetAdminOrdersQuery,
  useUpdateOrderFulfillmentMutation,
  useCreatePublicOrderStatusLinkMutation,
} =
  ordersApiSlice;